/**
 * @generated SignedSource<<56da60c48bbada0abbe1c68a72db82e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateUserProfilePassword = {
  oldPassword: string;
  newPassword: string;
};
export type userUpdateUserProfilePasswordMutation$variables = {
  id: string;
  input: UpdateUserProfilePassword;
};
export type userUpdateUserProfilePasswordMutation$data = {
  readonly updateUserProfilePassword: boolean;
};
export type userUpdateUserProfilePasswordMutation = {
  variables: userUpdateUserProfilePasswordMutation$variables;
  response: userUpdateUserProfilePasswordMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "updateUserProfilePassword",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userUpdateUserProfilePasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userUpdateUserProfilePasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fb4bb5c7d71a2779736dcf2cc4ffdf42",
    "id": null,
    "metadata": {},
    "name": "userUpdateUserProfilePasswordMutation",
    "operationKind": "mutation",
    "text": "mutation userUpdateUserProfilePasswordMutation(\n  $id: ID!\n  $input: UpdateUserProfilePassword!\n) {\n  updateUserProfilePassword(id: $id, input: $input)\n}\n"
  }
};
})();

(node as any).hash = "9d25cc3976654194258cd4d2f5d86b6e";

export default node;
